import { createApp } from 'vue'
import App from './App.vue'
import pinia from './plugins/pinia'
import { configureSentry, initSentry } from './plugins/sentry'
import vuetify from './plugins/vuetify'
import { router } from './router'
import './style.css'

const app = createApp(App)

app
  .use(vuetify)
  .use(pinia)
  .use(router)

initSentry(app)
app.mount('#app')

// --- Lazy-load Sentry after mount ---
if ('requestIdleCallback' in window) {
  requestIdleCallback(async () => {
    configureSentry(app, router)
  })
}
else {
  setTimeout(async () => {
    configureSentry(app, router)
  }, 300)
}

// Lazy-load GA after idle time
if ('requestIdleCallback' in window) {
  requestIdleCallback(async () => {
    const { default: ga } = await import('~/plugins/googleAnalytics')
    app.use(ga)
  })
}
else {
  setTimeout(async () => {
    const { default: ga } = await import('~/plugins/googleAnalytics')
    app.use(ga)
  }, 300)
}
